import SiteFooter from '@/components/feature/SiteFooter';
import SiteNavbar from '@/components/feature/SiteNavbar';
import { About, GlobalReach, Hero, Products, Quality, Sustainability } from './components/Sections';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <SiteNavbar />
      <main>
        <Hero />
        <About />
        <Products />
        <Quality />
        <GlobalReach />
        <Sustainability />
      </main>
      <SiteFooter />
    </div>
  );
}